<template>
    <div id="goals" style="height:100%; width:100%;">
        <b-col class="px-0 mx-0" style="height:100%; width:100%;">
            <DefaultPageComponent
            :loading="loading"
            :title="'Gráfico de comparação de carteiras'"
            :haveBackButton="true"
            @onBack="$router.push({name: 'dashboard'})"
            :haveContentMargin="true"
            :hideOverflow="isGraphicVisible"
            >

            <template #filters>
                <b-row class="mx-0">
                    <b-col class="px-2">
                        <div class="form-group">
                            <label for="">Assessor:</label>
                            <b-select class="form-control form-control-sm" id="inputPesquisarPor" style="box-shadow: none; height: 56px;"
                            @change="getCustomers" :value="null" v-model="advisor" :disabled="loading">	
                                <option v-for="item,idx in advisors" :key="idx" :value="item.id"> {{ item.first_name + " " + item.last_name }} </option>
                            </b-select>
                        </div>
                    </b-col>
                    <b-col class="px-2" v-if="tabIndex==1 || tabIndex==3">
                        <div class="form-group">
                            <label for="">Cliente:</label>
                            <b-form-select class="form-control form-control-sm" id="inputPesquisarPor" style="box-shadow: none; height: 56px;"
                            v-model="customer" :disabled="loading || tabIndex==0 || tabIndex==2">
                                <option :value="null" disabled> {{ 'Selecione' }} </option>
                                <option v-for="item,idx in customers" :key="idx" :value="item.xp_code">
                                    {{ item.xp_code+" - "+item.customer_full_name }}
                                </option>
                            </b-form-select>
                        </div>
                    </b-col>
                    <b-col class="px-2">
                        <CustomButton
                        v-if="tabIndex==1 || tabIndex==3"
                        :loading="loading"
                        :disabled="isDisabled"
                        @click="getItems"
                        :width="'260px'"
                        v-show="false"
                        > Pesquisar
                        </CustomButton>
                    </b-col>
                    <b-col class="px-1"></b-col>
                    <b-col class="px-1"></b-col>
                </b-row>
            </template>

            <!-- CONTENT -->
            <div style="position:relative; min-height: 100%; width: 100%;">
                <!-- <b-tabs @input="getItems" v-model="tabIndex"> -->
                <b-tabs v-model="tabIndex" @input="handleTabChange">
                <!-- <b-tabs v-model="tabIndex" @input="()=>{
                    if(tabIndex==0 || tabIndex==2)
                        getItems();
                    else if(tabIndex==1 || tabIndex==3)
                        verify();
                }"> -->
                    <b-tab title="Top Funds">
                        
                        <div class="p-3">
                            <b-row no-gutters align-h="end">
                                <b-col cols="auto" class="mr-2">
                                    <CustomButton
                                    @click="exportPDF"
                                    :width="'260px'"
                                    :loading="isGraphicVisible"
                                    v-if="user.permissions.portfolio_comparison == 1"
                                    > 
                                    <b-icon icon="file-earmark-pdf" class="mr-2"></b-icon>
                                        Gerar PDF
                                    </CustomButton>
                                </b-col>

                                <b-col cols="auto">
                                    <CustomButton
                                    @click="openNewView"
                                    :width="'260px'"
                                    > 
                                        <b-icon class="mr-2" icon="arrow-up-right-square-fill"></b-icon>
                                        Visualizar em nova aba
                                    </CustomButton>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="p-3 px-4">
                            <b-col class="p-0" style="background-color:black; width:100%; overflow: hidden;" ref="chart">
                                <DualGraphicsComponent
                                    v-if="tabIndex==0 && items?.length>0" 
                                    :params="params"
                                    chartKey="topFunds"
                                    :loading="loading"
                                    :modal="items"
                                />
                                <DualGraphicsSecondPdfComponent
                                    v-if="isGraphicVisible && tabIndex==0"
                                    :params="params"
                                    chartKey="topFundsPdf"
                                    :loading="loading"
                                    :modal="items"
                                    :tabIndex="tabIndex"
                                />
                            </b-col>
                        </div>
                    </b-tab>
                    <b-tab title="Fundos">
                        <div class="p-3">
                            <b-row no-gutters align-h="end">
                                <b-col cols="auto" class="mr-2">
                                    <CustomButton
                                    :disabled="!canGeneratePDF"
                                    @click="canGeneratePDF ? exportPDF() : null"
                                    :width="'260px'"
                                    :loading="isGraphicVisible"
                                    :class="{'pdf-disabled': !canGeneratePDF}"
                                    :title="!canGeneratePDF ? 'Selecione e pesquise um cliente primeiro' : ''"
                                    v-if="user.permissions.portfolio_comparison == 1"
                                    >
                                    <b-icon icon="file-earmark-pdf" class="mr-2"></b-icon>
                                        Gerar PDF
                                    </CustomButton>
                                </b-col>

                                <b-col cols="auto">
                                    <CustomButton
                                    @click="openNewView"
                                    :width="'260px'"
                                    > 
                                        <b-icon class="mr-2" icon="arrow-up-right-square-fill"></b-icon>
                                        Visualizar em nova aba
                                    </CustomButton>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="p-3 px-4">
                            <b-col class="p-0" style="background-color:#17375E; width:100%; color: white;">
                                <DualGraphicsSecondComponent
                                    v-if="tabIndex==1 && items?.length>0"
                                    :params="params"
                                    chartKey="funds"
                                    :loading="loading"
                                    :modal="items"
                                />
                                <DualGraphicsPdfComponent
                                v-if="isGraphicVisible && tabIndex==1"
                                :params="params" 
                                chartKey="fundsPdf" 
                                :loading="loading" 
                                :modal="items"
                                :customer="customerData"
                                :tabIndex="tabIndex"
                                />
                            </b-col>
                        </div>
                    </b-tab>
                    <b-tab title="Top Funds Previdência">
                        <div class="p-3">
                            <b-row no-gutters align-h="end">
                                <b-col cols="auto" class="mr-2">
                                    <CustomButton
                                    @click="exportPDF"
                                    :width="'260px'"
                                    :loading="isGraphicVisible"
                                    v-if="user.permissions.portfolio_comparison == 1"
                                    > 
                                    <b-icon icon="file-earmark-pdf" class="mr-2"></b-icon>
                                        Gerar PDF
                                    </CustomButton>
                                </b-col>

                                <b-col cols="auto">
                                    <CustomButton
                                    @click="openNewView"
                                    :width="'260px'"
                                    > 
                                        <b-icon class="mr-2" icon="arrow-up-right-square-fill"></b-icon>
                                        Visualizar em nova aba
                                    </CustomButton>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="p-3 px-4">
                            <b-col class="p-0" style="background-color:Black; width:100%;">
                                <DualGraphicsComponent
                                    v-if="tabIndex==2 && items?.length>0" 
                                    :params="params" 
                                    chartKey="topPensionFunds" 
                                    :loading="loading"
                                    :modal="items.map(i=>{
                                        return {
                                            fund: i.fund,
                                            n_document: i.n_document,
                                            roa: i.roa,
                                            twelve_months_volatility: i.volatility,
                                            absolute_return_12_months: i.absolute_return_12m,
                                        }
                                    })"
                                />
                                <DualGraphicsSecondPdfComponent
                                v-if="isGraphicVisible && tabIndex==2"
                                :params="params" 
                                chartKey="topPensionFundsPdf" 
                                :loading="loading"
                                :tabIndex="tabIndex"
                                :modal="items.map(i=>{
                                    return {
                                        fund: i.fund,
                                        n_document: i.n_document,
                                        roa: i.roa,
                                        twelve_months_volatility: i.volatility,
                                        absolute_return_12_months: i.absolute_return_12m,
                                    }
                                })"/>
                            </b-col>
                        </div>
                    </b-tab>
                    <b-tab title="Previdência">
                        <div class="p-3">
                            <b-row no-gutters align-h="end">
                                <b-col cols="auto" class="mr-2">
                                    <CustomButton
                                    :disabled="!canGeneratePDF"
                                    @click="canGeneratePDF ? exportPDF() : null"
                                    :width="'260px'"
                                    :loading="isGraphicVisible"
                                    :class="{'pdf-disabled': !canGeneratePDF}"
                                    v-if="user.permissions.portfolio_comparison == 1"
                                    > 
                                    <b-icon icon="file-earmark-pdf" class="mr-2"></b-icon>
                                        Gerar PDF
                                    </CustomButton>
                                </b-col>

                                <b-col cols="auto">
                                    <CustomButton
                                    @click="openNewView"
                                    :width="'260px'"
                                    > 
                                        <b-icon class="mr-2" icon="arrow-up-right-square-fill"></b-icon>
                                        Visualizar em nova aba
                                    </CustomButton>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="p-3 px-4">
                            <b-col class="p-0" style="background-color:#17375E; width:100%; color: white;">
                                <DualGraphicsSecondComponent
                                    v-if="tabIndex==3 && items?.length>0"
                                    :params="params"
                                    chartKey="pension"
                                    :loading="loading"
                                    :modal="items.map(i=>{
                                    return {
                                        fund: i.fund,
                                        n_document: i.n_document,
                                        roa: i.roa,
                                        twelve_months_volatility: i.volatility,
                                        absolute_return_12_months: i.absolute_return_12m,
                                    }
                                })"
                                />
                                <DualGraphicsPdfComponent
                                v-if="isGraphicVisible && tabIndex==3"
                                :params="params" 
                                chartKey="pensionPdf" 
                                :loading="loading"
                                :customer="customerData"
                                :tabIndex="tabIndex"
                                :modal="items.map(i=>{
                                    return {
                                        fund: i.fund,
                                        n_document: i.n_document,
                                        roa: i.roa,
                                        twelve_months_volatility: i.volatility,
                                        absolute_return_12_months: i.absolute_return_12m,
                                    }
                                })"/>
                            </b-col>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>

            <template #footer>
                <div></div>
            </template>

            </DefaultPageComponent>

        </b-col>
    </div>
</template>

<script>
import DefaultPageComponent from '@/components/DefaultPageComponent.vue';
import CustomButton from '@/components/CustomButton.vue';
import DualGraphicsComponent from '@/components/DualGraphicsComponent.vue'
import DualGraphicsSecondComponent from '@/components/DualGraphicsSecondComponent.vue';
import DualGraphicsPdfComponent from '@/components/DualGraphicsPdfComponent.vue'
import DualGraphicsSecondPdfComponent from '@/components/DualGraphicsSecondPdfComponent.vue'
import { mapState } from 'vuex';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
    name: "PortfolioComparisonView",
    components:{
        CustomButton,
        DefaultPageComponent,
        DualGraphicsComponent,
        DualGraphicsSecondComponent,
        DualGraphicsPdfComponent,
        DualGraphicsSecondPdfComponent,
    },
    data(){
        return {
            loading: false,
            loadingSubmit: false,
            isGraphicVisible: false,
            tabIndex: parseInt(this.$route.query.i) || 0,
            advisors: [],
            customers: [],
            advisor: null,
            customer: null,
            customerSearched: null,
            hasSearched: false,
            params: [],
            items: [],
            columns: [
                {
                    'ADVISOR': 
                    {
                        label: 'Assessor',
                        class: 'text-left',
                    }
                },
            ],
        }
    },
    async mounted(){
        if(this.$route.query.i) this.tabIndex = parseInt(this.$route.query.i);
        if(this.$route.query.c) this.customer = this.$route.query.c;

        this.getFixedIndicators();
        await this.getAdvisors();
        await this.getItems();
    },
    computed:{
        ...mapState('user', {
            user: (state) => state.user,
        }),
        isDisabled(){
            return (
                this.loading 
                || this.loadingSubmit 
                || (
                    (this.tabIndex==1 || this.tabIndex==3)
                    && (
                        !this.advisor 
                        || !this.customer
                    )
                   )
            );
        },
        customerData(){
            return this.customers.find(a=>a.xp_code==this.customerSearched)
        },
        canGeneratePDF() {
            return this.customer && this.hasSearched;
        },
    },
    methods: {
        openNewView(){
            const routeData = this.$router.resolve({name: 'portfolioComparison', query: {i: this.tabIndex, c: this.customer}});
            window.open(routeData.href, '_blank');
        },
        verify(){
            const needsClient = (this.tabIndex === 1 || this.tabIndex === 3);
            if (needsClient && (!this.advisor || !this.customer)) {
                this.$swal({
                title: 'Atenção',
                text: 'Selecione um cliente.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#28A745',
                allowOutsideClick: false,
                customClass: {
                    confirmButton: 'custom-confirm-button-class',
                }
                });
                return false;
            }
            return true;
        },
        handleTabChange(newIndex) {
            this.tabIndex = newIndex;

            const needsClient = (newIndex === 1 || newIndex === 3);
            const hasClient = this.advisor && this.customer;

            if (needsClient && !hasClient) {
            this.items = []; // limpa os dados anteriores
            this.hasSearched = false;

            this.$swal({
                title: 'Atenção',
                text: 'Selecione um cliente.',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#28A745',
                allowOutsideClick: false,
                customClass: {
                confirmButton: 'custom-confirm-button-class',
                },
            });
            } else {
            this.getItems();
            }
        },
        async getItems() {
            if ((this.tabIndex === 1 || this.tabIndex === 3) && (!this.advisor || !this.customer)) {
                this.items = [];
                return;
            }

            try {
                this.loading = true;
                let endpoint = null;

                if (this.tabIndex == 0) endpoint = 'top-funds/chart-data';
                else if (this.tabIndex == 1) endpoint = 'customers/portfolio';
                else if (this.tabIndex == 2) endpoint = 'top-pension-funds/chart-data';
                else if (this.tabIndex == 3) endpoint = 'customers/portfolio';

                if (this.tabIndex == 1 || this.tabIndex == 3) {
                    if (this.advisor) endpoint += '?advisor_id=' + this.advisor;
                    if (this.customer) endpoint += '&customer_id=' + this.customer;

                    if (this.tabIndex == 1) endpoint += '&classification_id=3';
                    else if (this.tabIndex == 3) endpoint += '&classification_id=1';
                }

                const response = await this.$axios.get(endpoint);
                this.items = response.data;
                this.customerSearched = String(this.customer);
                this.hasSearched = this.customer && this.items.length > 0;

                if (this.items.length === 0) {
                    this.$swal({
                        title: 'Atenção',
                        text: 'Nenhuma informação foi retornada.',
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#28A745',
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: 'custom-confirm-button-class',
                        }
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        // async getAdvisors(){
        //     const response = await this.$axios.get('advisors');
        //     this.advisors = response.data.data.filter(e=>e.advisorCommercialPartner[0]?.code);
        // },
        async getFixedIndicators () {
            try{
                const response = await this.$axios.get('https://profiles.wflowinvest.app/api/fixed_indicator')
                this.params = response.data.data.filter(e=>e.name.toUpperCase()=='CDI' || e.name.toUpperCase()=='BOVESPA');
            }
            catch(error){
                console.log(error);
            }
        },
        async getAdvisors () {
            try{
                const user = {...this.user};
                const response = await this.$axios.get('advisors')
                this.advisors = response.data.data;
    
                if (user.hunter_ids.length > 0)
                    this.advisors = this.advisors.filter(advisor => {
                        return user.hunter_ids.includes(advisor.id)
                    });
                this.getUserAdvisor();
            }
            catch(error){
                console.log(error);
            }
        },
        getUserAdvisor(){
            this.advisor = this.advisors.find(e=>e.id==this.user.advisor_id).id
            this.getCustomers();
        },
        async getCustomers(){
            try{
                const response = await this.$axios.get('advisors/customers-details?advisor_id='+this.advisor)
                this.customers = response.data[0]?.customers;
            }
            catch(error){
                console.log(error);
            }
        },
        async save(){
            // if(!this.file) {
            //     this.$swal({
            //         title: 'Atenção',
            //         text: 'A importação do arquivo é obrigatória.',
            //         icon: 'warning',
            //         confirmButtonText: 'OK',
            //         confirmButtonColor: '#28A745',
            //         allowOutsideClick: false,
            //         customClass: {
            //             confirmButton: 'custom-confirm-button-class',
            //         }
            //     });
            //     return false;
            // }
            // try{
            //     this.loading = true;
            //     this.loadingSubmit = true;

            //     const post = await this.saveGoalsFileImport();
                
            //     await Promise.all([post]);
                
            //     this.$swal({
            //         title: 'Sucesso',
            //         text: 'Arquivo importado com sucesso.',
            //         icon: 'success',
            //         confirmButtonText: 'OK',
            //         confirmButtonColor: '#28A745',
            //         allowOutsideClick: false,
            //         focusConfirm: false,
            //         customClass: {
            //             confirmButton: 'custom-confirm-button-class',
            //         }
            //     });
    
            //     this.clear();
            //     this.$refs.modalNewGoal.closeModal();
            // }
            // catch(error){
            //     console.log(error);
            //     this.$swal({
            //         title: 'Atenção',
            //         text: 'Houve um erro com a importação do arquivo!',
            //         icon: 'error',
            //         confirmButtonText: 'OK',
            //         confirmButtonColor: '#28A745',
            //         allowOutsideClick: false,
            //         customClass: {
            //             confirmButton: 'custom-confirm-button-class',
            //         }
            //     });
            // }
            // finally {
            //     this.loading = false;
            //     this.loadingSubmit = false;
            // }
        },
        async exportPDF() {
            try {
                this.isGraphicVisible = true;
                await this.$nextTick();
                await new Promise(res => setTimeout(res, 5000));

                const element = document.getElementById('dualGraphicsPdfChart');
                if (!element) {
                console.error("Elemento não encontrado");
                return;
                }

                // 1. Guarda estilos originais
                const original = {
                display:  element.style.display,
                height:   element.style.height,
                width:    element.style.width,
                overflow: element.style.overflow
                };

                // 3. Ajusta tamanho para captura
                element.style.display  = 'block';
                element.style.overflow = 'visible';
                element.style.height   = element.scrollHeight + 'px';
                element.style.width    = element.scrollWidth  + 'px';
                window.dispatchEvent(new Event('resize'));
                await this.$nextTick();

                // 4. Captura e gera PDF
                const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true
                });
                const imgData = canvas.toDataURL('image/png');

                const pdf = new jsPDF('l', 'mm', 'a4');
                const pageWidth  = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                const imgHeight  = (canvas.height * pageWidth) / canvas.width;

                let position   = 0;
                let heightLeft = imgHeight;

                pdf.addImage(imgData, 'PNG', 0, position, pageWidth, imgHeight);
                heightLeft -= pageHeight;
                while (heightLeft > 0) {
                position -= pageHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, pageWidth, imgHeight);
                heightLeft -= pageHeight;
                }

                var name = null;
                if (this.tabIndex == 0) name = "Top Funds - WFLOW"
                else if (this.tabIndex == 1) name = "Fundos - Cliente "+ this.customerData.xp_code +" - "+ this.customerData.customer_full_name;
                else if (this.tabIndex == 2) name = "Top Funds Previdência - WFLOW"
                else if (this.tabIndex == 3) name = "Previdência - Cliente "+ this.customerData.xp_code +" - "+ this.customerData.customer_full_name;
                pdf.save(name + ".pdf");

                element.style.display  = original.display;
                element.style.height   = original.height;
                element.style.width    = original.width;
                element.style.overflow = original.overflow;
                window.dispatchEvent(new Event('resize'));
                await this.$nextTick();

            } catch (error) {
                console.error("Erro ao exportar PDF:", error);
            } finally {
                this.isGraphicVisible = false;
            }
        },
    },
    watch: {
        customer(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.hasSearched = false;
                this.getItems();
            }
        },
        tabIndex(newVal) {
            if (newVal === 1 || newVal === 3) {
                if (this.customer) {
                    this.getItems();
                }
            } else {
                this.customer = null;
                this.customerSearched = null;
                this.hasSearched = false;
                this.items = [];
            }
        }
    },
}
</script>

<style scoped>
/* * /deep/ .modal-card{
    max-width:fit-content !important;
} */

* /deep/ .nav-link{
    width: 220px !important;
    text-align: center !important;
    color: #FFF !important;
    background-color: #5C5C58 !important;
    border: 2px solid #1C1B1B !important;
    border-radius: 0px !important;
    font-weight: 600;
}
* /deep/ .active{
    color: #FFF !important;
    background: #262625 !important;
    border: 2px solid #1C1B1B !important;
}
* /deep/ .tab-content{
    background-color: #262625 !important;
}
* /deep/ .nav-tabs {
    border-bottom: 2px solid #1C1B1B !important;
}

.pdf-disabled {
    cursor: not-allowed !important;
}
</style>